"use client";

import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { PRODUCT_PAGE_METADATA_SHIFT_V2_250521 } from "@faire/web-api--source/indigofair/settings/PRODUCT_PAGE_METADATA_SHIFT_V2_250521";

export const useAssignSettingProductPageMetadataShift = () =>
  useAssignSetting(PRODUCT_PAGE_METADATA_SHIFT_V2_250521);

export const useProductPageMetadataShift = () => {
  return useSetting(
    PRODUCT_PAGE_METADATA_SHIFT_V2_250521,
    IThreeVariantXP.Bucket.CONTROL
  ) as IThreeVariantXP.Bucket;
};

export const shouldUseUpdatedImagePicker = (bucket: IThreeVariantXP.Bucket) => {
  return bucket === IThreeVariantXP.Bucket.VARIANT_2;
};

export const shouldUseMetadataZippies = (bucket: IThreeVariantXP.Bucket) => {
  return (
    bucket === IThreeVariantXP.Bucket.VARIANT_2 ||
    bucket === IThreeVariantXP.Bucket.VARIANT_3
  );
};
